import React, { useState } from 'react';
import './Stitching.css';
import { Link } from 'react-router-dom';

// Import images from assets
import stitchingImage1 from '../assets/stitching1.png';
import stitchingImage2 from '../assets/stitching2.png';
import stitchingImage3 from '../assets/stitching3.png';

const Stitching = () => {
  const [isExpanded, setIsExpanded] = useState(false); // State for collapsible section

  const toggleExpand = () => {
    setIsExpanded(!isExpanded); // Toggle the expanded state
  };

  return (
    <div className="stitching-container">
      <h1>Stitching Intervention</h1>
      <p>This page is about the Stitching Intervention. It explains the purpose, goals, and impact of the intervention.</p>

      {/* Collapsible Section */}
      <div className="accordion">
        <button onClick={toggleExpand} className="toggle-button">
          {isExpanded ? 'Hide Details' : 'Show Details'}
        </button>
        {isExpanded && (
          <div className="accordion-content">
            <p>
              The Stitching Intervention focuses on empowering women artisans through skill development in stitching.
              Our goal is to enhance their skills, provide them with access to resources, and create sustainable livelihoods.
            </p>
            <p>
              We believe that by teaching these skills, we can uplift families and contribute to the community's overall well-being.
            </p>
          </div>
        )}
      </div>

      {/* Image Gallery Section */}
      <h2>Our Stitching Projects</h2>
      <div className="stitching-images">
        <img
          src={stitchingImage1}
          alt="Stitching Project 1"
          className="stitching-image hover-effect"
        />
        <img
          src={stitchingImage2}
          alt="Stitching Project 2"
          className="stitching-image hover-effect"
        />
        <img
          src={stitchingImage3}
          alt="Stitching Project 3"
          className="stitching-image hover-effect"
        />
      </div>

      {/* Navigation Buttons */}
      <div className="navigation-buttons">
        <Link to="/intervention/rugs" className="nav-button">Go to Rugs</Link>
        <Link to="/intervention/bamboo" className="nav-button">Go to Bamboo</Link>
        <Link to="/intervention/basketry" className="nav-button">Go to Basketry</Link>
      </div>
    </div>
  );
}

export default Stitching;
